import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { FeaturesPage } from './pages/FeaturesPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { PricingPage } from './pages/PricingPage';
import { ContactPage } from './pages/ContactPage';
import { LoginPage } from './pages/LoginPage';
export function App() {
  const location = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/features" element={<FeaturesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/how-it-works" element={<HowItWorksPage data-id="element-9" />} data-id="element-8" />
          <Route path="/testimonials" element={<TestimonialsPage data-id="element-11" />} data-id="element-10" />
          <Route path="/pricing" element={<PricingPage data-id="element-13" />} data-id="element-12" />
          <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
          <Route path="/login" element={<LoginPage data-id="element-17" />} data-id="element-16" />
          {/* Catch-all route for other pages to show contact or home */}
          <Route path="*" element={<HomePage data-id="element-19" />} data-id="element-18" />
        </Routes>
      </main>
      <Footer data-id="element-20" />
    </div>;
}